import { Component } from "vue";
import { RawLocation } from "vue-router";
import BoardFolderList from '@board/components/BoardFolderList.vue'
import FolderList from '@mail/components/FolderList.vue'
import CalendarFolderList from '@calendar/components/CalendarFolderList.vue'
import WorkflowFolderList from '@workflow/components/WorkflowFolderList.vue'
import { i18n } from "@appbase/util"
import store from '@/store'

export interface MenuInfo {
    name: string
    path: RawLocation | Component
    type: string
    icon: string
    select: boolean
    route: string[]
    isUse: boolean
}

const current = store.state.$account?.current
const isMailOnly = (): boolean => {
    if (current) {
        if (current.user.deptCode.indexOf('MAILONLY') > -1) {
            return true
        } else {
            return false
        }
    } else {
        return false
    }
}

const menues: MenuInfo[] = [
    {
        name: i18n.t('홈').toString(),
        path: { name: 'home-main' },
        type: 'router-link',
        icon: 'home1',
        select: true,
        route: ['home-main'],
        isUse: !isMailOnly()
    },
    {
        name: i18n.t('알림').toString(),
        path: { name: 'home-alarm' },
        type: 'router-link',
        icon: 'bell',
        select: false,
        route: ['home-alarm'],
        isUse: !isMailOnly()
    },
    {
        name: i18n.t('W_Common_Search').toString(),
        path: { name: 'home-search' },
        type: 'router-link',
        icon: 'search',
        select: false,
        route: ['home-search'],
        isUse: !isMailOnly()
    },
    // {
    //     name: '조직도',
    //     path: { name: 'home-orgmap' },
    //     type: 'router-link',
    //     icon: 'address',
    //     select: false
    // },
    {
        name: i18n.t('메일').toString(),
        path: FolderList, // 메일 폴더, 연락처 폴더
        type: 'router-link',
        icon: 'email',
        select: false,
        route: ['mail-home', 'mail-list', 'contact-list'],
        isUse: true
    },
    {
        name: i18n.t('게시판').toString(),
        path: BoardFolderList,
        type: 'router-link',
        icon: 'community',
        select: false,
        route: ['board-list'],
        isUse: !isMailOnly()
    },
    {
        name: i18n.t('전자결재').toString(),
        path: WorkflowFolderList,
        type: 'router-link',
        icon: 'approval2',
        select: false,
        route: ['workflow-list'],
        isUse: !isMailOnly()
    },
    {
        name: i18n.t('일정').toString(),
        path: CalendarFolderList,
        type: 'router-link',
        icon: 'time',
        select: false,
        route: ['calendar-main'],
        isUse: !isMailOnly()
    },
]

export default menues